
  window.NadosI18n = (function () {
  var WB = {};                                      // Woerterbuch: assets/nados-en-0 … nados-en-4.js

  (function () {                                   // Woerterbuch-Dateien und eigene Uebersetzungen aus den Theme-Einstellungen
    function norm(x) { return String(x).replace(/\s+/g, ' ').trim(); }
    var zusatz = window.NadosEN || {};
    for (var k in zusatz) { if (Object.prototype.hasOwnProperty.call(zusatz, k)) WB[norm(k)] = zusatz[k]; }
    String(window.NadosENEigen || '').split(/\r?\n/).forEach(function (z) {
      var i = z.indexOf('=>'), l = 2;
      if (i < 0) { i = z.indexOf('='); l = 1; }
      if (i <= 0) return;
      var de = norm(z.slice(0, i)), en = norm(z.slice(i + l));
      if (de && en) WB[de] = en;
    });
  })();
  var lang = 'de';
  try {
    var m = String(location.search || '').match(/[?&]lang=(de|en)/);
    if (m) lang = m[1];
  } catch (e) {}

  var eintraege = [];
  var beschaeftigt = false;

  function schluessel(s) { return String(s).replace(/\s+/g, ' ').trim(); }

  function t(s) {
    var k = schluessel(s);
    if (lang !== 'en') return k;
    return uebersetzeEn(k);
  }
  function wb(k) { return Object.prototype.hasOwnProperty.call(WB, k) ? WB[k] : null; }
  function uebersetzeEn(k) {
    var x = wb(k), m;
    if (x !== null) return x;
    if ((m = /^ab (\d[\d.,]*\s?€\*?)$/.exec(k))) return 'from ' + m[1];          // Preis „ab …“
    if ((m = /^(Sorten|Inhalt):\s*(.+)$/.exec(k))) return (wb(m[1] + ':') || m[1] + ':') + ' ' + uebersetzeEn(m[2]);
    if (/^\d+\s?× /.test(k)) {                                                   // Sortenliste „2× Name, 1× Name“
      return k.split(/,\s*/).map(function (teil) {
        var n = /^(\d+\s?× )(.+)$/.exec(teil);
        return n ? n[1] + (wb(n[2]) || n[2]) : (wb(teil) || teil);
      }).join(', ');
    }
    return k;
  }

  function mitRand(orig, neu) {
    return orig.match(/^\s*/)[0] + neu + orig.match(/\s*$/)[0];
  }

  function erfasseText(wurzel) {
    var neu = [];
    var w = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (n.__nadosErfasst) continue;
      if (!schluessel(n.nodeValue)) continue;
      var p = n.parentNode;
      if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') continue;
      n.__nadosErfasst = true;
      var e = { node: n, de: n.nodeValue };
      eintraege.push(e); neu.push(e);
    }
    return neu;
  }

  function erfasseAttribute(wurzel) {
    var neu = [];
    if (!wurzel.querySelectorAll) return neu;
    ['placeholder', 'aria-label', 'title', 'alt'].forEach(function (attr) {
      var liste = wurzel.querySelectorAll('[' + attr + ']');
      Array.prototype.forEach.call(liste, function (el) {
        var marke = 'nados' + attr.replace('-', '');
        if (el.dataset && el.dataset[marke]) return;
        var wert = el.getAttribute(attr);
        if (!wert) return;
        if (el.dataset) el.dataset[marke] = '1';
        var e = { el: el, attr: attr, de: wert };
        eintraege.push(e); neu.push(e);
      });
    });
    return neu;
  }

  function setze(liste) {
    beschaeftigt = true;
    liste.forEach(function (e) {
      if (e.node) {
        var neu = (lang === 'en') ? mitRand(e.de, t(e.de)) : e.de;
        if (e.node.nodeValue !== neu) e.node.nodeValue = neu;
      } else if (e.el) {
        e.el.setAttribute(e.attr, (lang === 'en') ? t(e.de) : e.de);
      }
    });
    beschaeftigt = false;
  }

  function aufraeumen() {
    eintraege = eintraege.filter(function (e) {
      var k = e.node || e.el;
      return !k || k.isConnected !== false;
    });
  }

  var beobachter = (typeof MutationObserver === 'function') ? new MutationObserver(function (muts) {
    if (beschaeftigt) return;
    var neu = [];
    muts.forEach(function (mu) {
      Array.prototype.forEach.call(mu.addedNodes, function (n) {
        if (n.nodeType === 3) {
          if (n.__nadosErfasst || !schluessel(n.nodeValue)) return;
          n.__nadosErfasst = true;
          var e = { node: n, de: n.nodeValue };
          eintraege.push(e); neu.push(e);
        } else if (n.nodeType === 1) {
          neu = neu.concat(erfasseText(n), erfasseAttribute(n));
        }
      });
    });
    if (neu.length) setze(neu);
  }) : null;

  function linksAnpassen() {
    var as = document.querySelectorAll('a[href]');
    Array.prototype.forEach.call(as, function (a) {
      var h = a.getAttribute('href');
      if (!h || /^(https?:|mailto:|tel:|javascript:)/i.test(h)) return;
      var hash = '';
      var i = h.indexOf('#');
      if (i >= 0) { hash = h.slice(i); h = h.slice(0, i); }
      if (!h && hash) return;                       // reiner Ankerlink: Seite bleibt
      h = h.replace(/([?&])lang=(de|en)&?/g, '$1').replace(/[?&]$/, '');
      if (lang === 'en') h += (h.indexOf('?') >= 0 ? '&' : '?') + 'lang=en';
      a.setAttribute('href', h + hash);
    });
  }

  function urlAnpassen() {
    try {
      var u = new URL(location.href);
      if (lang === 'en') u.searchParams.set('lang', 'en'); else u.searchParams.delete('lang');
      history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
  }

  function knoepfeAnpassen() {
    var bs = document.querySelectorAll('.lang-btn');
    Array.prototype.forEach.call(bs, function (b) {
      var aktiv = b.getAttribute('data-lang') === lang;
      b.classList.toggle('active', aktiv);
      b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
    });
  }

  function setLang(neueSprache) {
    if (neueSprache !== 'de' && neueSprache !== 'en') return;
    if (neueSprache === lang) return;
    lang = neueSprache;
    aufraeumen();
    setze(eintraege);
    linksAnpassen();
    urlAnpassen();
    knoepfeAnpassen();
    document.documentElement.setAttribute('lang', lang);
    try {
      document.dispatchEvent(new CustomEvent('nados:lang', { detail: lang }));
    } catch (e) {}
  }

  function start() {
    erfasseText(document.body);
    erfasseAttribute(document.body);
    if (beobachter) beobachter.observe(document.body, { childList: true, subtree: true });
    if (lang === 'en') setze(eintraege);
    linksAnpassen();
    knoepfeAnpassen();
    document.documentElement.setAttribute('lang', lang);
    var bs = document.querySelectorAll('.lang-btn');
    Array.prototype.forEach.call(bs, function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        setLang(b.getAttribute('data-lang'));
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  return { t: t, set: setLang, get: function () { return lang; } };
  })();
  